import { defer, LoaderFunctionArgs } from 'react-router-dom';
import { fromBase64 } from 'js-base64';
import { IFetchNewPairsPayload, ITicker } from '@kattana-io/common';
import { KattanaAPI, store } from '../../store/createStore';
import { ITableSort } from '../../molecules/Table/DesktopTable';
import { authTokenSelector } from '../../selectors/auth';

export type newPairsPageLoaderPDataType = ITicker[] | null;

const newPairsLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const page = Number(url.searchParams.get('page') || 1);
  const chain = url.searchParams.get('chain') || 'ETH';
  const liquidity = url.searchParams.get('liquidity') || undefined;
  const sort = url.searchParams.get('sort');

  const authToken = authTokenSelector(store.getState());

  const payload: IFetchNewPairsPayload = { chain, liquidity };

  if (sort) {
    const parsedSort: ITableSort = JSON.parse(fromBase64(sort));
    payload.sort = {
      name: parsedSort.id,
      order: parsedSort.isSortedDesc ? 'DESC' : 'ASC',
    };
  }
  if (page > 1) {
    payload.page = (page - 1).toString();
  }

  const tickers = KattanaAPI.newPairs(payload, authToken, request.signal);

  return defer({ tickers });
};

export default newPairsLoader;
